import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CurrentUserService, MixpanelService, UserPreferencesService } from '@core/services';
import { TranslateModule } from '@ngx-translate/core';
import { UserPreferenceKeysEnum } from '@shared/enums';
import { AutoFocusModule } from 'primeng/autofocus';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
    selector: 'app-announcement-modal',
    standalone: true,
    imports: [DialogModule, TranslateModule, AutoFocusModule, ButtonModule, NgOptimizedImage],
    templateUrl: './announcement-modal.component.html',
    styleUrls: ['./announcement-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnnouncementModalComponent {
    private readonly currentUser = toSignal(this.currentUserService.currentUser$, {
        initialValue: this.currentUserService.currentUser$.value,
    });

    readonly canCurrentUserUseSequencing = computed(() => this.currentUser()?.canUseSequencing ?? false);

    readonly isVisible = signal(false);

    constructor(
        private userPreferencesService: UserPreferencesService,
        private mixpanelService: MixpanelService,
        private currentUserService: CurrentUserService
    ) {
        effect(
            () => {
                if (!this.currentUser()) this.isVisible.set(false);

                this.isVisible.set(
                    this.userPreferencesService.getPreferenceValue(UserPreferenceKeysEnum.SHOW_WELCOME_MODAL) ?? false
                );
            },
            { allowSignalWrites: true }
        );

        effect(() => {
            if (this.isVisible() === true) this.mixpanelService.logOpenModal('dashboard-announcement-modal');
        });
    }

    savePreference() {
        const newPreference: { key: UserPreferenceKeysEnum; value: boolean } = {
            key: UserPreferenceKeysEnum.SHOW_WELCOME_MODAL,
            value: false,
        };
        this.userPreferencesService.saveUserPreferences(newPreference);
    }
}
